import { CSSProperties } from 'react';

import createSvgIcon from 'shared/utils/createSvgIcon';

const styles: CSSProperties = {
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeMiterlimit: 10,
  strokeWidth: 2,
  fill: 'none',
};

export default createSvgIcon(
  <g>
    <line style={styles} x1="10" y1="3.01" x2="10" y2="10.99" />
    <path style={styles} d="M14.9,8,10,12.93,5.1,8" />
    <line style={styles} x1="3.68" y1="16.99" x2="16.32" y2="16.99" />
  </g>,
  '0 0 20 20'
);
